var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFencing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 82.4,
    cy: 32.1,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,64.3c-2.3,2.3-3.4,5.2-3.4,8.2V102l-20.3,20.3c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0l20.3-20.3H67c1.3,0,2.6-0.5,3.6-1.5 c2-2,2-5.3,0-7.3L34.4,64.3z M54.5,99H41.3V85.8L54.5,99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,63.1h-29.5c-0.6-4.4-4.4-7.8-9-7.8h-1.4v3.9H89.6L55.1,24.7c-0.9-0.9-2.2-1.5-3.6-1.5H30.8c-2.8,0-5.1,2.3-5.1,5.1 s2.3,5.1,5.1,5.1h18.4l7.9,7.9L38,60.7L54.3,77l19.3-19.3L83.8,68c1,1,2.3,1.5,3.6,1.5h16.7v3.9h1.4c4.6,0,8.4-3.4,9-7.8H144V63.1z  M106.9,70.6V58.2c2.9,0.6,5,3.2,5,6.2C111.9,67.4,109.8,70,106.9,70.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFencing);
export default __webpack_public_path__ + "static/media/fencing.cc57f88cf34d55096111670a7983fb4e.svg";
export { ForwardRef as ReactComponent };